import { createTableItem } from "../../../objects/AssetsExpenses/create_table_item";

export const createNewHomeInsObj = (homeFullCost, gameDate, expenseTable, bedrooms, homeAge) => {
        let riskMultiplier = 1;
        let bedroomAdjust = 1.0;
        
        switch (bedrooms){
            case "1":
            case "2":
                bedroomAdjust = .95;
                break;
            case "4":
                bedroomAdjust = 1.1;
                break;
            default:
                break;
        }
        let ageAdjust = 1;
        if (+homeAge < 10){
            ageAdjust = .95;
        }else{
            if (+homeAge > 30){
                ageAdjust = 1.1;
            }
        }
        riskMultiplier = bedroomAdjust * ageAdjust;
        const annualInsCost = .0035 * homeFullCost * riskMultiplier;
        const homeInsAmt = (annualInsCost / 12).toFixed(2);
        let homeInsObj = createTableItem("homeIns", "", gameDate, 
            homeInsAmt, "", false);
        expenseTable.push(homeInsObj);
        const returnObj = {homeInsAmt: homeInsAmt, expenseTable: expenseTable};
        return returnObj;
    }

export default createNewHomeInsObj;